module.exports = __webpack_public_path__ + "img/icon-client-card@3x.13cad543.png";